import React, { FunctionComponent } from 'react';
import AllSubscriptions from 'src/models/AllSubscriptions';
import styles from './update-subscription-preview.module.scss';
import {
  isUserFromNewZealand,
  isUserFromUK,
  isChallengeBundleActive,
  detectActiveCurrency,
  getCurrencySymbol,
} from 'src/lib/utils';
import { useSelector } from 'react-redux';
import { IAppState } from 'src/store';
import SubscriptionDiscountDisplay from './subscription-discount-display';

interface OwnProps {
  allSubscriptions: AllSubscriptions | undefined;
}

const UpcomingSubscription: FunctionComponent<OwnProps> = ({
  allSubscriptions,
}) => {
  const user = useSelector((state: IAppState) => state.auth?.user);

  const activeCurrency = detectActiveCurrency(allSubscriptions);

  const isNewZealandUser = activeCurrency
    ? activeCurrency === 'nzd'
    : !isChallengeBundleActive() &&
      (isUserFromNewZealand() || (user?.country ?? '') === 'New Zealand');

  const isUKUser = activeCurrency ? activeCurrency === 'gbp' : isUserFromUK();

  const currencySymbol = getCurrencySymbol(
    activeCurrency || isNewZealandUser,
    isUKUser,
    true
  );

  const upcoming = allSubscriptions?.upcomingSubscription;

  let fullAmount = 0;
  if (activeCurrency === 'nzd') {
    fullAmount = (upcoming?.currencyOptions?.nzd?.unit_amount || 1) / 100;
  } else if (activeCurrency === 'gbp') {
    fullAmount = (upcoming?.currencyOptions?.gbp?.unit_amount || 1) / 100;
  } else if (activeCurrency === 'aud') {
    fullAmount = (upcoming?.currencyOptions?.aud?.unit_amount || 1) / 100;
  } else {
    fullAmount = isNewZealandUser
      ? (upcoming?.currencyOptions?.nzd?.unit_amount || 1) / 100
      : upcoming?.price ?? 0;
  }

  return (
    <div className={styles.changeSubscriptionPreview}>
      <div className={styles.price}>
        <div className={styles.big}>{upcoming?.planName} </div>
        <div className={styles.nextDate}>
          <SubscriptionDiscountDisplay
            invoiceDiscount={upcoming?.invoiceDiscount}
            pricing={{
              fullAmount,
              intervalCount: upcoming?.intervalCount ?? 1,
              interval: upcoming?.interval ?? 'month',
            }}
            isNewZealandUser={activeCurrency === 'nzd' || isNewZealandUser}
            currencySymbol={currencySymbol}
          />
        </div>
      </div>

      <div className={styles.nextDate}>
        In effect from {upcoming?.startDate}
      </div>
    </div>
  );
};

export default UpcomingSubscription;
